import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-newsticker-loader',
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './newsticker-loader.component.html',
  styleUrls: ['../newsticker.component.scss'],
})
export class NewstickerLoaderComponent {}
